exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selected-optionv2{background-color:#4a90e2!important;color:#fff}.option-cardv2{-webkit-transition:all .3s ease;transition:all .3s ease;cursor:pointer}.option-cardv2:hover{-webkit-transform:translateY(-4px);transform:translateY(-4px);-webkit-box-shadow:0 6px 15px rgba(0,0,0,.1);box-shadow:0 6px 15px rgba(0,0,0,.1)}", ""]);

// exports
